import React, { useCallback, useEffect, useState } from 'react'
import moment from 'moment'
import _ from 'lodash'

import Context from './context'

function Index(props) {
    const {
        children
    } = props

    const [user, setUser] = useState()
    const [cart, setCart] = useState()
    const [reloadData, setReloadData] = useState()
    const [messages, setMessages] = useState([])
    const [states, setStates] = useState([])
    const [countries, setCountries] = useState([])

    const removeMessage = useCallback((message) => {
        setMessages(
            _.without(messages, message)
        )
    }, [messages])

    const sendMessage = useCallback((message, type = 'success') => {
        setMessages([
            { message, type, createdAt: moment().add(10, 'seconds') },
            ...messages,
        ])
    }, [messages, setMessages])

    const clearMessages = useCallback(() => {
        setMessages([])
    }, [])

    const contextData = {
        user,
        setUser,
        messages,
        sendMessage,
        removeMessage,
        clearMessages,
        cart,
        setCart,
        reloadData,
        setReloadData,
        states,
        setStates,
        countries,
        setCountries,
    }

    useEffect(() => {
        let timer

        const cleanup = () => {
            const now = moment()
            const updatedMessages = _.filter(messages, (message) => {
                return now.isBefore(message.createdAt)
            })

            if (updatedMessages.length < messages.length) {
                setMessages(updatedMessages)
            }

            if (updatedMessages.length > 0) {
                timer = setTimeout(cleanup, 1000)
            } else {
                clearTimeout(timer)
            }
        }

        if (messages.length > 0 && !timer) {
            cleanup()
        }

        return () => clearTimeout(timer)
    }, [messages])

    return (
        <Context.Provider value={contextData}>
            {children}
        </Context.Provider>
    )
}

export default Index

